<template>
  <div>
    <v-card flat class="custom-grey-border remove-border-radius">
      <v-card-title class="headline grey lighten-4">
        <h3 class="font-weight-700 custom-headline color-custom-blue">SLOTS
        </h3>
      </v-card-title>
      <v-card-text class="p-6 font-size-16">
        <div>

          <div class="m-3">
            <v-btn @click="addSlotDialog = !addSlotDialog"
              class="mt-0 mb-3 custom-grey-border custom-bold-button white--text" color="cyan">
              Add Slot
            </v-btn>
          </div>
        </div>
        <v-card flat class="custom-grey-border remove-border-radius">
          <div v-if="createdSlots?.length > 0">

            <div v-for="(slot_data, index) in createdSlots" :key="index">

              <v-card-title class="headline grey lighten-4">
                <h3 class="font-weight-700 custom-headline color-custom-blue">Slots Duration ({{ slot_data?.slot_type ??  slot_data?.house_type
                }})
                </h3>
                <v-spacer></v-spacer>
                <div class="d-flex">
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="updateSlot(slot_data, index)" color="cyan" large v-bind="attrs" v-on="on"
                        class="mr-2">
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Click here to update slot </span>

                  </v-tooltip>
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="deleteSchedule(index)" color="deep-orange" large v-bind="attrs" v-on="on">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Click here to delete</span>
                  </v-tooltip>
                </div>

              </v-card-title>
              <v-card-text class="p-6 font-size-16">
                <table width="100%" style="border-collapse: collapse">
                  <thead>
                    <tr style="background-color: #e5e1e1">
                      <th style="padding: 10px; text-align: center; font-weight: bold">
                        Slots Start
                      </th>
                      <th style="padding: 10px; text-align: center; font-weight: bold">
                        Slots End
                      </th>

                      <th style="padding: 10px;   font-weight: bold">
                        Status
                      </th>
                      <th style="padding: 10px; text-align: center; font-weight: bold">
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(slot, slotIndex) in slot_data?.slots" :key="slotIndex" :style="{
                      backgroundColor: slotIndex % 2 != 0 ? '#f5f5f5' : '#ffffff',
                      borderBottom: '1px solid #e5e1e1',
                      padding: '10px'
                    }">
                      <td align="center" valign="middle" style="padding: 10px">
                        {{ slot?.start }}
                      </td>
                      <td align="center" valign="middle" style="padding: 10px">
                        {{ slot?.end }}
                      </td>
                      <td>
                        <v-switch v-model.trim="slot.is_active" inset :true-value="1" :false-value="0" color="green"
                          hide-details class="mt-0"></v-switch>
                      </td>
                      <td valign="middle">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon @click="deleteSlot(index, slotIndex)" color="deep-orange" v-bind="attrs" v-on="on"
                              align="center">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Click here to delete </span>
                        </v-tooltip>
                      </td>

                    </tr>

                  </tbody>
                </table>
              </v-card-text>
            </div>
          </div>
          <div v-else class="mt-3 mb-3">
            <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
              <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
              Uhh... There are no slots at the moment.
            </p>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
    <CreateSlots @saveUpdatedSlots="saveUpdatedSlots" :addSlot_dialog="addSlotDialog"
      :gapBetweenSlots="original.gap_between_slots" :editSlotData="original"
      :slot_duration_type="original.duration_type" v-on:close-dialog="addSlotDialog = false" />
  </div>
</template>
<script>

import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import CreateSlots from "@/view/components/CreateSlots.vue";

export default {
  data() {
    return {
      productCreate: [],
      createdSlots: [],
      updateSlotIndex: null,
      addSlotDialog: false,
      slots: [],
      // dates_off: [],
      // updated_weeks: [],
      // updatedSlots: [],
      // durationType: [
      //   { day_of_week: "Minutes", value: "minutes" },
      //   { day_of_week: "Hours", value: "hours" },
      // ],
      original: {

      },

    };
  },
  watch: {
    createdSlots: {
      handler() {
        this.$emit("updatedSlots", this.createdSlots);
      },
      deep: true,
    },

  },
  components: {
    // TimePicker,
    // Dialog,
    CreateSlots
  },
  computed: {

  },
  mounted() {
    // this.getHolidays();
  },
  created() {
    // if (this.allSlots) {
    //   setTimeout(() => {
    //     this.updateSlotWeekDays = this.allSlots;
    //   }, 500);
    //   this.viewAllSlots = true;
    // }
    // if (this.same_slots == 'same_slot') {
    //   this.view_same_slots = true;
    // }
    if (this.details?.createdSlots) this.createdSlots = this.details?.createdSlots

  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    same_slots: {
      type: String,
      default: 'different_slot',
    },
    allSlots: {
      type: Array,
      default: null,
    },
    serviceID: {
      type: [Number, String],
      default: 0,
    },
    details: {
      type: Object,
      default: null,
    },
  },
  methods: {
    saveUpdatedSlots(
      param,
      slot_duration,
      duration_type,
      start_time,
      end_time,
      gap_between_slots,
    ) {
      if (this.updateSlotIndex != null) {
        this.createdSlots[this.updateSlotIndex] =
        {
          slot_type: slot_duration + ' ' + duration_type,
          slots: param,
          gap_between_slots: gap_between_slots,
          start_time: start_time,
          end_time: end_time,
          slot_duration: slot_duration,
          duration_type: duration_type,
        }
      }

      else {

        this.createdSlots.push(
          {
            slot_type: slot_duration + ' ' + duration_type,
            slots: param,
            gap_between_slots: gap_between_slots,
            start_time: start_time,
            end_time: end_time,
            slot_duration: slot_duration,
            duration_type: duration_type,
          }

        );
      }

      this.addSlotDialog = false;
      this.updateSlotIndex = null

    },
    deleteSchedule(index) {
      this.createdSlots.splice(index, 1);
    },

    deleteSlot(index, slotIndex) {
   
      this.createdSlots[index].slots.splice(slotIndex, 1);
    },

    updateSlot(data, index) {
      this.original = data;
      this.addSlotDialog = true;
      this.updateSlotIndex = index;
    },



    // updateEndTime() {
    //   let [time, modifier] = this.original.start_time.split(" ");
    //   let [hours, minutes] = time.split(":").map(Number);

    //   // Convert to 24h
    //   if (modifier === "PM" && hours !== 12) hours += 12;
    //   if (modifier === "AM" && hours === 12) hours = 0;

    //   // Add minutes
    //   let totalMinutes = hours * 60 + minutes + Number(this.original.slot_duration);

    //   // Convert back to h:mm AM/PM
    //   let newHours = Math.floor(totalMinutes / 60) % 24;
    //   let newMinutes = totalMinutes % 60;

    //   let ampm = newHours >= 12 ? "PM" : "AM";
    //   newHours = newHours % 12 || 12;

    //   this.original.end_time = `${newHours}:${String(newMinutes).padStart(2, "0")} ${ampm}`;

    // },
    // toMinutes(timeStr) {
    //   const [time, modifier] = timeStr.split(" ");
    //   let [hours, minutes] = time.split(":").map(Number);

    //   if (modifier === "PM" && hours !== 12) hours += 12;
    //   if (modifier === "AM" && hours === 12) hours = 0;

    //   return hours * 60 + (minutes || 0);
    // },

    emptyValue() {
      this.original.end_time = null;
      this.original.slot_duration = null;
      this.original.start_time = null;
      this.original.slot_duration = null;
      this.original.duration_type = null;
    },
  },

}
</script>
<style scoped>
.removeShadow>.v-input__control>.v-input__slot {
  box-shadow: none !important;
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  padding: 0;
}

.v-application .py-3 {
  padding-bottom: 0px !important;
}

.text-right.col-md-12.col {
  margin: -10px;
}

.styled-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
}

.styled-table th,
.styled-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.styled-table th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-align: left;
}

.styled-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.styled-table tr:hover {
  background-color: #f1f1f1;
}
</style>
